import { IMunicipio } from '@app/modules/parametrizacao/municipio/model/municipio.model';
import { IEntity, User } from 'viggo-sistemas-core-web';

export enum TIPO_SEXO {
  MASCULINO = 'MASCULINO',
  FEMININO = 'FEMININO',
  OUTRO = 'OUTROS'
}


export enum PARCEIRO_EVENTO_SALDO_ENUM {
  AJUSTAR_VALOR = 'AJUSTAR_VALOR',
  ADICIONAR_VALOR = 'ADICIONAR_VALOR',
  REMOVER_VALOR = 'REMOVER_VALOR'
}

export interface ParceiroEventoSaldoCredito {
  novo_valor: number;
  numero_entidade: string;
  entidade_id: string;
  ajuste_direto: boolean;
  desconsidera_contas_abertas: boolean;
  observacao: string;
}

export interface ParceiroEventoSaldoCreditoResult extends IEntity {
  domain_id: string;
  parceiro_id: string;
  entidade_id: string;
  status: string;
  tipo: string;
  seq: number;
  saldo_credito: number;
  saldo_credito_pre: number;
  saldo_credito_pos: number;
  descricao: string;
  ajuste: boolean;
}

/**
 * representa os contatos vindos do backend
 */
export interface IParceiroContato extends IEntity {
  contato: string;
  tag: string | string[];
  // tags: any[]; //TAGLIST de produto
}

/**
 * interface que representa o endereço salvo no backend
 */
export interface IParceiroEndereco extends IEntity {
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  municipio_id: string;
  cep: string;
  ponto_referencia: string;
  municipio: IMunicipio;
}

export interface IParceiro extends IEntity {
  domain_id: string;
  cpf_cnpj: string;
  nome_razao_social: string;
  rg_insc_est: string;
  apelido_nome_fantasia: string;
  enderecos: IParceiroEndereco[];
  contatos: IParceiroContato[];
  user_id: string;
  user?: User;
  data_nascimento?: string | Date;
  saldo_credito: number;
  codigo?: number;
}

export class Parceiro implements IParceiro {
  domain_id: string;
  cpf_cnpj: string;
  nome_razao_social: string;
  rg_insc_est: string;
  apelido_nome_fantasia: string;
  enderecos: IParceiroEndereco[];
  contatos: IParceiroContato[];
  saldo_credito: number;
  id: string;
  created_at: Date;
  created_by: string;
  updated_at: Date;
  updated_by: string;
  active: boolean;
  tag?: string | string[];
  user_id: string;
  user?: User;
  data_nascimento?: string | Date;
  toString(): string {
    return this.nome_razao_social;
  }
}
